import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { listOwners, mapApiOwnerToUi } from '../../../services/recordFormOptions.js';

/**
 * People who can own a record, searched on the server.
 *
 * `fetchIdRef` matters here more than anywhere: a user types faster than the
 * endpoint answers, and without the guard the slowest query wins.
 */
export function useOwnerSearch() {
  const [query, setQuery] = useState('');
  const [owners, setOwners] = useState([]);
  const [loading, setLoading] = useState(true);
  const fetchIdRef = useRef(0);

  useEffect(() => {
    const requestId = ++fetchIdRef.current;
    setLoading(true);
    (async () => {
      try {
        const { body } = await listOwners({ search: query ? { query } : undefined });
        if (requestId === fetchIdRef.current) setOwners((body?.items ?? []).map(mapApiOwnerToUi));
      } catch {
        if (requestId === fetchIdRef.current) setOwners([]);
      } finally {
        if (requestId === fetchIdRef.current) setLoading(false);
      }
    })();
  }, [query]);

  const search = useCallback((next) => setQuery(next ?? ''), []);

  return useMemo(() => ({ owners, loading, search }), [owners, loading, search]);
}

export default useOwnerSearch;
